import React, { Component } from 'react';

class ContainerMid extends Component {
    constructor(props){
        super(props);
        this.state = {
            collMid: [
                {
                    id: 1,
                    subtitle: 'Capítulo 3',
                    title: 'Fundamentos de Sistemas Adaptativos y Teoría de la Información',
                    text: 'Este capítulo introduce las bases de los sistemas adaptativos: análisis de series temporales, similitud, error cuadrático y persistencia de la excitación. Además, explora el potencial de la información como herramienta clave en el diseño de controladores adaptativos.'
                },
                {
                    id: 2,
                    subtitle: 'Capítulo 4',
                    title: 'Identificación de Sistemas Dinámicos Discretos',
                    text: 'Se presentan métodos analíticos y prácticos para la identificación de sistemas de distintos órdenes, desde el dominio de la función de transferencia hasta el espacio de estados. Incluye técnicas como Sine Sweep, aprendizaje en línea y el uso de redes neuronales para el modelado de sistemas.'
                }
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collMid.map((data,i)=> (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerMid;
